import TourPage from "@/components/TourPage";

export default function TanzaniaSafari6Day() {
  return (
    <TourPage
      tourId="tanzania/safari-6-day"
      title="6 Days Safari to Tanzania"
      duration="6 Days / 5 Nights"
      price="Contact for price"
      image="/serengetiwildbeastmigration.png"
      description="Journey through a 6-day safari adventure in Tanzania, exploring the breathtaking landscapes and incredible wildlife of Lake Manyara National Park, Tarangire National Park, Serengeti National Park, and Ngorongoro Crater."
      itinerary={[
        {
          day: 1,
          title: "Arrival",
          description: "Begin your Tanzania safari adventure.",
          activities: [
            "Arrive at Kilimanjaro International Airport (JRO)",
            "Transfer to Arusha for overnight"
          ],
          accommodation: "Lodge in Arusha",
          meals: "Dinner"
        },
        {
          day: 2,
          title: "Arusha to Tarangire National Park",
          description: "Explore Tarangire National Park's diverse wildlife.",
          activities: [
            "Drive to Tarangire National Park for a game drive (with picnic lunch)",
            "Spot elephants, wildebeests, zebras, and gazelles"
          ],
          accommodation: "Lodge in Tarangire",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 3,
          title: "Tarangire to Lake Manyara National Park",
          description: "Discover Lake Manyara's unique ecosystem.",
          activities: [
            "Drive to Lake Manyara National Park for a game drive (with picnic lunch)",
            "Witness the alkaline waters and diverse birdlife"
          ],
          accommodation: "Lodge near Lake Manyara",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 4,
          title: "Lake Manyara to Serengeti National Park",
          description: "Journey to the famous Serengeti National Park.",
          activities: [
            "Drive to Serengeti National Park through Ngorongoro Conservation Area",
            "Stop at Olduvai Gorge (optional) and visit a local Masai Boma",
            "Sunset game drive in Serengeti National Park"
          ],
          accommodation: "Lodge in Serengeti",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 5,
          title: "Serengeti National Park to Ngorongoro Crater",
          description: "Experience the wonders of Serengeti and travel to Ngorongoro.",
          activities: [
            "Hot air balloon ride (optional) to see nocturnal predators and animals waking up",
            "Game drive in Serengeti National Park",
            "Drive to Ngorongoro Crater for dinner and overnight"
          ],
          accommodation: "Lodge at Ngorongoro",
          meals: "Breakfast, Lunch, Dinner"
        },
        {
          day: 6,
          title: "Ngorongoro Crater Tour and Return to Arusha",
          description: "Explore the incredible Ngorongoro Crater before departure.",
          activities: [
            "Descend into Ngorongoro Crater for a game drive (with picnic lunch)",
            "Witness the incredible array of wildlife, including lions, elephants, and rhinos",
            "Drive back to Arusha for drop-off"
          ],
          meals: "Breakfast, Lunch"
        }
      ]}
      inclusions={[
        "Pick up and drop off at the airport",
        "Ngorongoro Crater car supplement fee",
        "1.5 mineral water per person per day",
        "All park entry fees and concession fees",
        "Government Taxes related to this safari",
        "Private 4x4 safari vehicle with pop-up roof, guaranteed window seat, refrigerator, and USB charging ports",
        "Professional English-speaking safari driver guide",
        "Accommodation and meals in lodges/camps as per itinerary",
        "Accommodation in Arusha before and after safari"
      ]}
      exclusions={[
        "International and domestic flight tickets",
        "Olduvai Gorge fees",
        "Airport taxes",
        "Item of personal Nature",
        "Visa fees, travel, and health insurance",
        "Alcoholic and non-alcoholic beverages",
        "Any other items of a personal nature, laundry, telephone, and postage",
        "Meals, drinks, and excursions not described in the itinerary",
        "Gratuities to your guide, hotel staff, and porters"
      ]}
    />
  );
}
